// RF-27d / CA-7c (spec 010): el SP manda `null` a propósito para distinguir "sin dato calculable" de
// "cero real" (DiasPromedio, conversión del embudo). Este es el ÚNICO lugar donde se traduce
// `null -> "—"`. Prohibido `|| 0` / `?? 0` sobre esos campos en cualquier componente: borrarían la
// distinción que el SP se tomó el trabajo de conservar.
export const fmt = (v) => (v === null || v === undefined ? "—" : v);

// Suma la columna de valor de un recordset-catálogo (estados, tier, vigilancia, clubhouse, tipoIA,
// estrategia, checklist, tendencia, champions). RF-27f: el SP siempre manda el catálogo completo con
// el valor en 0 — incluido el roster de champions, que sale por LEFT JOIN para no esconder a los que
// hoy tienen carga 0 — así que "vacío" se decide por la SUMA, nunca por `array.length`: el arreglo
// siempre trae filas y preguntar por su longitud pintaría barras de largo cero.
// `key` existe porque champions mide en `Habilitadas`, no en `Total`.
export const sumaTotal = (filas, key = "Total") =>
  Array.isArray(filas) ? filas.reduce((acc, fila) => acc + (Number(fila && fila[key]) || 0), 0) : 0;

// Redondea a 1 decimal SIN tocar `null` (a diferencia de `Math.round`, que convertiría `null` en `0`
// silenciosamente). Se compone con `fmt()`: `fmt(redondear1(titulares.DiasPromedio))`.
export const redondear1 = (v) => (v === null || v === undefined ? null : Math.round(v * 10) / 10);

export default fmt;
